import { Helmet } from 'react-helmet-async';

export function TermsPage() {
  return (
    <>
      <Helmet>
        <title>Términos de Servicio - LyricsHub</title>
      </Helmet>
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-text-primary mb-6">Términos de Servicio</h1>
        <div className="prose prose-invert max-w-none space-y-4 text-text-secondary text-sm leading-relaxed">
          <p>Última actualización: {new Date().getFullYear()}</p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">
            1. Aceptación de los Términos
          </h2>
          <p>
            Al acceder y utilizar LyricsHub, aceptas estar sujeto a estos términos de servicio. Si
            no estás de acuerdo con alguna parte de estos términos, no debes utilizar nuestro
            servicio.
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">
            2. Descripción del Servicio
          </h2>
          <p>
            LyricsHub es una plataforma que permite consultar letras de canciones, traducciones, y
            contenido relacionado con la música. El servicio se proporciona "tal cual" sin
            garantías.
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">3. Propiedad Intelectual</h2>
          <p>
            Las letras de las canciones son propiedad de sus respectivos autores, compositores y
            discográficas. LyricsHub no reclama autoría sobre el contenido de las letras.
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">4. Conducta del Usuario</h2>
          <p>
            Los usuarios se comprometen a no utilizar el servicio para actividades ilegales, no
            publicar contenido ofensivo, y respetar los derechos de otros usuarios.
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">5. Contacto</h2>
          <p>Para consultas sobre estos términos, contacta a soporte@lyricshub.com</p>
        </div>
      </div>
    </>
  );
}
